import React from "react";
import { ArrowRightIcon } from "lucide-react";
type CtaButtonProps = {
  className?: string;
};
export function CtaButton({
  className = ""
}: CtaButtonProps) {
  return <a href="#oferta" className={`group inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-xl bg-gold px-7 py-4 font-display text-base font-extrabold uppercase tracking-wide text-ink shadow-[0_6px_0_0_#9A7120] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-gold-bright active:translate-y-[3px] active:shadow-[0_3px_0_0_#9A7120] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 sm:text-lg ${className}`} data-id="element-51" data-mp="hjvua36oxiot">
      Quiero mi MegaPack ahora
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-52" data-mp="vb0jscgcgulf" />
    </a>;
}